// src/pages/admin/AdminDashboard.tsx
import React from "react";
import Breadcrumb from "../../core/common/Breadcrumb/breadcrumb";
import AdminSidebar from "./AdminSidebar";
import Header from "../../core/common/header/header"; // 👈 importar o header
import { Outlet, useLocation } from "react-router-dom";

const AdminDashboard = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const breadcrumbMap: { [key: string]: string } = {
    "/admin/dashboard": "Painel",
    "/admin/admin-users": "Admins",
    "/admin/empresas": "Empresas",
    "/admin/services": "Serviços",
  };

  const secondBreadcrumbLabel =
    Object.keys(breadcrumbMap).find((path) => currentPath.includes(path))
      ? breadcrumbMap[
          Object.keys(breadcrumbMap).find((path) => currentPath.includes(path))!
        ]
      : "Admin";

  const breadcrumbs = [
    {
      label: "Dashboard",
      link: "/admin/dashboard",
      active: currentPath === "/admin/dashboard",
    },
    { label: secondBreadcrumbLabel, active: true },
  ];

  return (
    <div>
      {/* Header global do admin */}
      <Header />

      {/* Breadcrumb dinâmico */}
      <Breadcrumb
        title="Painel do Administrador"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-01"
      />

      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <AdminSidebar />
            </div>

            {/* Conteúdo principal */}
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header">
                  <h6>Painel do Administrador</h6>
                </div>
                <div className="card-body">
                  {/* Outlet para as páginas internas */}
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

